<monitoring-header componentName="{{ serviceName }}"></monitoring-header>
<div style="display: flex; flex-direction: column; justify-content: space-evenly; align-items: center; align-content: space-around; height: 85%">
  <mat-card style="width: 30%">
    <mat-card-content>
      <div class="container">
        <button mat-stroked-button color="primary"
          style="margin-left:5px; margin-right:5px"
          class="item" 
          *ngFor="let data of cardData | keyvalue" 
          [class.hide]="!((data.key| GetUserActivityNameByKey) === 'Registered Active Users' || (data.key| GetUserActivityNameByKey) === 'Users Logged In Today')"
          (click)="goToUserList(data.key)">
          <div style="font-size: 40px; margin-bottom: 2px;">{{data.value}}</div>
          <div style="font-size: 12px; text-align: center;">{{data.key | GetUserActivityNameByKey}}</div>
          <mat-icon color="primary" style="transform: scale(1.4); margin-top: 2px;">arrow_circle_right</mat-icon>     
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card style="width: 65%">
    <mat-card-content>
      <div class="container">
        <div class="item" 
          *ngFor="let data of cardData | keyvalue"
          [class.hide]="(data.key| GetUserActivityNameByKey) === 'Registered Active Users' || (data.key| GetUserActivityNameByKey) === 'Users Logged In Today'">
          <div style="font-size: 40px; margin-bottom: 2px;">{{data.value}}</div>       
          <div style="font-size: 12px; text-align: center;">{{data.key | GetUserActivityNameByKey}}</div>
          <mat-icon style="transform: scale(1.4); margin-top: 8px;">{{iconMapping[data.key]}}</mat-icon>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>